import React from 'react';
import { Helmet } from 'react-helmet';

export default function Metadata() {
  return (
    <Helmet>
        <meta charset="utf-8" />
        <meta name="description" content="Campaigning Tool is the smartest WhatsApp engagement platform, powered by official WhatsApp Business APIs. Effortlessly broadcast offers, automate notifications, and streamline customer support—all in one place! 🚀"/>
        <meta name="keywords" content="Campaigning Tool,WhatsApp Engagement Platform, WhatsApp Business API, Automated WhatsApp Marketing, WhatsApp Broadcast Messages, WhatsApp Chatbot Automation, WhatsApp Lead Generation, Customer Support Automation, WhatsApp Bulk Messaging, AI-Powered WhatsApp Campaigns, WhatsApp Notification Automation" />
        <title>Campaigning Tool</title>
        <meta property="og:url" content="https://www.campaigningtool.com" />
        <link rel="canonical" href="https://www.campaigningtool.com"/>
        <meta name="author" content="Campaigning Tool"/>
        <meta property="og:site_name" content="Campaigning Tool"/>
    </Helmet>
  );
}
